"use strict";'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var reactDom = require('react-dom');
var l = require('styled-components');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var l__default = /*#__PURE__*/_interopDefaultLegacy(l);

var o=({children:e,container:r=document.body})=>reactDom.createPortal(jsxRuntime.jsx(l.StyleSheetManager,{target:r,children:jsxRuntime.jsx(jsxRuntime.Fragment,{children:e})}),r);o.displayName="Portal";var P=l__default["default"](o)``;

exports.a = P;
